import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { MobileStepper } from "@/components/MobileStepper/MobileStepper";

type Props = {
  totalSteps: number;
  currentStepNumber: number;
  currentStepTitle?: ReactNode;
};

export const ProgressStepper = ({
  totalSteps,
  currentStepNumber,
  currentStepTitle,
}: Props) => {
  const intl = useIntl();

  return (
    <div>
      <MobileStepper
        variant="progress"
        steps={totalSteps}
        position="static"
        activeStep={currentStepNumber}
      />

      <div className="flex w-full items-center gap-2">
        <span className="text-sm text-text-secondary">
          {intl.formatMessage(
            {
              defaultMessage: "Step {currentStep}/{totalSteps}",
              description:
                "Step indicator in a multi-step process (e.g. 'Step 2 of 4')",
            },
            { currentStep: currentStepNumber, totalSteps },
          )}
        </span>

        {currentStepTitle ? (
          <h5 className="text-sm font-medium text-text-title">
            {currentStepTitle}
          </h5>
        ) : null}
      </div>
    </div>
  );
};
